import React, { useState } from 'react';

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {/* ░░ NAV ░░ */}
<nav id="nav">
  <div className="nav-inner">
    <a className="nav-logo-wrap" href="#">
      <img src="/logo.png" alt="Speedvault Logo" style={{ height: '48px', width: 'auto' }} />
    </a>
    <ul className="nav-links" id="navLinks">
      <li><a href="#" data-section="hero">Home</a></li>
      <li><a href="#solutions" data-section="sol1">Solutions</a></li>
      <li><a href="#hiw" data-section="hiw">How It Works</a></li>
      <li><a href="#industries" data-section="ind">Industries</a></li>
      <li><a href="#why" data-section="why">Why Us</a></li>
    </ul>
    <div className="nav-right">
      <a className="btn-nav-cta btn-shimmer" href="https://speedvault.in/contact_us">Contact Us</a>
    </div>
    <button 
      className={`hamburger ${isOpen ? 'open' : ''}`} 
      id="hamburger" 
      aria-label="Menu"
      onClick={toggleMenu}
    >
      <span className="ham-bar"></span><span className="ham-bar"></span><span className="ham-bar"></span>
    </button>
  </div>
</nav>

{/* ░░ MOBILE DRAWER ░░ */}
<div className={`mobile-drawer ${isOpen ? 'open' : ''}`} id="mobileDrawer">
  <a href="#" onClick={closeMenu}>Home</a>
  <a href="#solutions" onClick={closeMenu}>Solutions</a>
  <a href="#hiw" onClick={closeMenu}>How It Works</a>
  <a href="#industries" onClick={closeMenu}>Industries</a>
  <a href="#why" onClick={closeMenu}>Why Us</a>
  <div className="drawer-divider"></div>
  <a href="https://speedvault.in/contact_us" className="drawer-cta" onClick={closeMenu}>Contact Us →</a>
</div>
    </>
  );
}

export default Nav;
